import { useState as t, useCallback as y, useEffect as f } from "react";
const V = () => +getComputedStyle(document.body).getPropertyValue(
  "--breakpoint-small"
).replace("px", ""), m = () => +getComputedStyle(document.body).getPropertyValue(
  "--breakpoint-medium"
).replace("px", ""), a = () => +getComputedStyle(document.body).getPropertyValue(
  "--breakpoint-large"
).replace("px", ""), l = () => window.innerWidth <= V(), d = () => window.innerWidth <= m(), p = () => window.innerWidth <= a(), u = () => window.innerWidth > m() && window.innerWidth <= a(), c = () => window.innerWidth > a(), h = () => {
  const [e, b] = t(l()), [n, w] = t(d()), [i, k] = t(
    p()
  ), [r, S] = t(u()), [o, g] = t(c()), s = y(() => {
    e !== l() && b(!e), n !== d() && w(!n), i !== p() && k(!i), r !== u() && S(!r), o !== c() && g(!o);
  }, [e, n, i, r, o]);
  return f(() => (window.addEventListener("resize", s), () => {
    window.removeEventListener("resize", s);
  }), [s]), {
    isSmall: e,
    isMobile: n,
    isTabletOrSmaller: i,
    isTablet: r,
    isDesktop: o
  };
};
export {
  d as a,
  l as b,
  p as c,
  u as d,
  c as i,
  a as l,
  m,
  V as s,
  h as u
};
//# sourceMappingURL=useBreakpoints-JBHunbIk.js.map
